import(/* webpackMode: "eager" */ "/home/runner/work/agger-customer/agger-customer/src/app/page.tsx");
